import { IProductOverview } from '@models/IProductOverview';
import useProductPageContentStore from '@state/ProductPageStore';
import classNames from 'classnames';

const ProductOverview = (props: IProductOverview) => {
  const { subtitle, text } =
    useProductPageContentStore().productPageContent?.productOverview || props;

  return (
    <section
      className="component-padding container bg-white pb-[160px] text-black-100"
      data-testid="CT-60-Product-Overview"
    >
      <div className="flex flex-col gap-7.5 md:gap-10 lg:w-3/5">
        {subtitle && (
          <p className="h3" data-testid="CT-60-Product-Overview-Subtitle">
            {subtitle}
          </p>
        )}

        <div
          className={classNames(
            subtitle ? 'body-two' : 'h3',
            'flex flex-col gap-4'
          )}
          dangerouslySetInnerHTML={{
            __html: text,
          }}
          data-testid="CT-60-Product-Overview-Text"
        />
      </div>
    </section>
  );
};

export default ProductOverview;
